import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class PutShiftSettingRegionEntity {
  region?: RegionMiniEntity
  generateJobPeriodInDays?: number | null
  numberOfGeneratedDays?: number | null
}
